const _shelfkey = 'kkComicMyShelf'
const _historykey = 'kkComicReadHistory'

function setShelf (shelf) {
  window.localStorage.setItem(_shelfkey, JSON.stringify(shelf))
}

function setHistory (history) {
  window.localStorage.setItem(_historykey, JSON.stringify(history))
}

const shelfService = {
  addShelf (bookInfo) {
    let res = false
    let shelf = this.getShelf()
    if (shelf.find(item => { return item.title === bookInfo.title })) {
      shelf = shelf.filter(item => item.title !== bookInfo.title)
    } else {
      shelf.splice(0, 0, bookInfo)
      res = true
    }
    setShelf(shelf)
    return res
  },
  getShelf () {
    const shelf = JSON.parse(window.localStorage.getItem(_shelfkey))
    if (shelf) {
      return shelf
    } else {
      return []
    }
  },
  addHistory (bookInfo, number, title) {
    const history = this.getHistory()
    const h = history.find(item => { return item.bookInfo.bookId.toString() === bookInfo.bookId.toString() })
    const hIndex = history.findIndex(item => item.bookInfo.title === bookInfo.title)
    if (h) {
      if (h.number !== number) {
        h.number = number
        h.title = title
        history.splice(hIndex, 1, h)
      }
    } else {
      history.push({ bookInfo, number: number, title: title, date: new Date() })
    }
    setHistory(history)
  },
  getHistory () {
    const history = JSON.parse(window.localStorage.getItem(_historykey))
    if (history) {
      return history.sort((a, b) => {
        const da = new Date(a.date)
        const db = new Date(b.date)
        return db - da
      })
    } else {
      return []
    }
  },
  getHistoryById (bookId) {
    return this.getHistory().find(item => {
      return item.bookInfo.bookId.toString() === bookId.toString()
    })
  },
  updateHistory (bookId, number, title) {
    const history = this.getHistory()
    const index = history.findIndex(item => item.bookInfo.bookId.toString() === bookId.toString())
    history[index].number = number
    history[index].date = new Date()
    history[index].title = title

    setHistory(history)
  }
}

export default shelfService
